const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';

const redirectSignIn = isLocalhost
  ? 'http://localhost:3000/login'
  : 'https://outfitterfinder.com/login';

const redirectSignOut = isLocalhost
  ? 'http://localhost:3000/login'
  : 'https://outfitterfinder.com/login';

const awsConfig = {
  aws_project_region: 'us-east-1',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_LxvQLAdow',
  aws_user_pools_web_client_id: 'lcgg0ibbpl8bjdo6dj3cg55l9',
  oauth: {
    domain: 'outfitterfinder.auth.us-east-1.amazoncognito.com',
    scope: ['email', 'openid', 'profile'],
    redirectSignIn,
    redirectSignOut,
    responseType: 'code',
  },
};

export default awsConfig;
